// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__VYoaN","label":"Radio_label__nk8UE","checkMark":"Radio_checkMark__2MhXz","disabled":"Radio_disabled__27pjX"};